// extracted by mini-css-extract-plugin
export default {"host":"style_host__GFbfT","title":"style_title__Rz4zo","table":"style_table__q3syB","signsFor":"style_signsFor__6aoJ0","order":"style_order__7XHwp"};